module.exports = __webpack_public_path__ + "media/assets/images/flags/bf-2c140aca7c7862e54daac4bc1bcb9917.svg";